import { useEffect, useLayoutEffect } from "react";
import { runningInBrowser } from "~/const/browser";

export const useIsomorphicEffect = () => {
  return runningInBrowser ? useLayoutEffect : useEffect;
};
